import { createSlice } from "@reduxjs/toolkit";

const findItem = (arr: string[], str: string) => {
  const res = arr.find((e: string) => e === str);
  return res ? true : false;
};

/**
 * Global error slice to handle error messages in the application
 */

const globalErrorSlice = createSlice({
  name: "globalErrorSlice",
  initialState: {
    auth: {
      errorMessages: [""],
    },
    summary: {
      errorMessages: [""],
    },
    manageFarmer: {
      errorMessages: [""],
    },
    manageSurveyor: {
      errorMessages: [""],
    },
  },
  reducers: {
    updateErrorMessage: (state, action) => {
      switch (action.payload.type) {
        case "auth": {
          const itemExists = findItem(
            state.auth.errorMessages,
            action.payload.message,
          );
          if (!itemExists) {
            state.auth.errorMessages = [
              ...state.auth.errorMessages,
              action.payload.message,
            ];
          }
          break;
        }

        case "summary": {
          const itemExists = findItem(
            state.summary.errorMessages,
            action.payload.message,
          );
          if (!itemExists) {
            state.summary.errorMessages = [
              ...state.summary.errorMessages,
              action.payload.message,
            ];
          }
          break;
        }

        case "manage-farmers": {
          const itemExists = findItem(
            state.manageFarmer.errorMessages,
            action.payload.message,
          );

          if (!itemExists) {
            state.manageFarmer.errorMessages = [
              ...state.manageFarmer.errorMessages,
              action.payload.message,
            ];
          }
          break;
        }
        case "manage-surveyors": {
          const itemExists = findItem(
            state.manageSurveyor.errorMessages,
            action.payload.message,
          );

          if (!itemExists) {
            state.manageSurveyor.errorMessages.push(action.payload.message);
          }
          break;
        }
        case "remove-auth": {
          state.auth.errorMessages = state.auth.errorMessages.filter(
            (e) => e !== action.payload,
          );
          break;
        }

        case "remove-summary": {
          state.summary.errorMessages = state.summary.errorMessages.filter(
            (e) => e !== action.payload.message,
          );
          break;
        }
        case "remove-manage-farmers": {
          state.manageFarmer.errorMessages =
            state.manageFarmer.errorMessages.filter(
              (e) => e !== action.payload.message,
            );
          break;
        }
        case "remove-manage-surveyors": {
          state.manageSurveyor.errorMessages =
            state.manageSurveyor.errorMessages.filter(
              (e) => e !== action.payload.message,
            );
          break;
        }

        default:
          throw "Invalid Action";
      }
    },
  },
});
export const { updateErrorMessage } = globalErrorSlice.actions;
export default globalErrorSlice.reducer;
